import { useState, useEffect, useRef } from "react";
import Image1 from "../assets/lucid-origin_Toyota_Innova_Crysta_2024_premium_model_pearl_white_color_with_metallic_finish_f-0.jpg";

// Font Awesome Icons
import { 
  FaTaxi, FaClock, FaLeaf, FaTrophy, FaCity, FaStar, FaShieldAlt, FaCreditCard,
  FaRocket, FaHandsHelping, FaCar, FaUsers, FaAward, FaMapMarkerAlt,
  FaPhone, FaEnvelope, FaFacebook, FaTwitter, FaInstagram, FaLinkedin,
  FaApple, FaGooglePlay, FaHeart, FaBolt, FaRegClock, FaShieldAlt as FaShield
} from 'react-icons/fa';

// Material Design Icons - CORRECTED
import { 
  MdMenu, MdClose, MdHome, MdInfo, MdPerson, 
  MdTimeline, MdDirectionsCar, MdLocalTaxi, MdEco, MdSecurity,
  MdSupport, MdDownload, MdGetApp, MdPeople, MdStar, MdLocationOn,
  MdHistory, MdVerified, MdDirectionsCarFilled
} from 'react-icons/md';

// Game Icons
import { 
  GiTrophy, GiCityCar, GiSteeringWheel, GiGears, GiFuelTank 
} from 'react-icons/gi';

// Feather Icons
import { 
  FiMapPin, FiUsers, FiStar, FiSun, FiHeart, FiAward, 
  FiClock, FiTrendingUp, FiSmile, FiThumbsUp, FiBriefcase,
  FiHome, FiInfo, FiUser, FiMap
} from 'react-icons/fi';

// Bootstrap Icons
import { 
  BsLightningCharge, BsShieldCheck, BsClockHistory, BsAward,
  BsCalendar, BsCalendarCheck, BsCalendarHeart
} from 'react-icons/bs';

// Ionicons
import { 
  IoMdCar, IoMdPeople, IoMdStar, IoMdTime,
  IoIosLeaf, IoIosTrophy, IoIosLocate
} from 'react-icons/io';


const YELLOW = "#FFD700";
const YELLOW_DARK = "#FFC200";
const YELLOW_LIGHT = "#FFF9D6";
const BLACK = "#0E0E0E";
const WHITE = "#FFFFFF";
const GRAY_BG = "#F7F7F7";

const teamMembers = [
  { icon: <GiSteeringWheel />, name: "Arjun Mehta", role: "Founder & CEO", bg: "#FFF5C2" },
  { icon: <FiUsers />, name: "Priya Nair", role: "Head of Tech", bg: "#E8F5E9" },
  { icon: <MdDirectionsCar />, name: "Ravi Kumar", role: "Fleet Manager", bg: "#E3F2FD" },
  { icon: <FiStar />, name: "Sneha Roy", role: "Design Lead", bg: "#FCE4EC" },
  { icon: <GiGears />, name: "Dev Sharma", role: "Operations", bg: "#EDE7F6" },
  { icon: <MdTimeline />, name: "Anika Bose", role: "Data & AI", bg: "#E0F7FA" },
];

const values = [
  { icon: <FaShieldAlt />, title: "Safety First", desc: "Every driver is background-verified, trained & insured. Real-time trip tracking for your peace of mind." },
  { icon: <FaBolt />, title: "Always On Time", desc: "We respect your time. Smart routing ensures you're never late for what matters most." },
  { icon: <FaHeart />, title: "Customer First", desc: "24/7 support, easy cancellations, and a team that genuinely cares about your experience." },
  { icon: <IoIosLeaf />, title: "Eco Commitment", desc: "30% of our fleet is electric or hybrid. We're driving toward a greener tomorrow." },
  { icon: <GiTrophy />, title: "Award Winning", desc: "Recognized as the Best Cab Service 3 years in a row by the Regional Transport Council." },
  { icon: <IoIosLocate />, title: "City Wide Coverage", desc: "Available across 15+ cities with a growing network of drivers ready 24/7." },
];

const timeline = [
  { year: "2021", title: "The Beginning", desc: "Founded with 10 cars and a dream to redefine city travel.", icon: <BsCalendar /> },
  { year: "2023", title: "Launched Our Website", desc: "Took the leap digital — bookings shot up 400% in year one.", icon: <FaApple /> },
  { year: "2024", title: "Gone Green", desc: "Introduced our first EV fleet and carbon offset programme.", icon: <IoIosLeaf /> },
  { year: "2025", title: "National Expansion", desc: "Expanded to 15 cities and crossed 1M total rides.", icon: <GiCityCar /> },
  { year: "2026", title: "50K Milestone", desc: "50,000 monthly active riders and growing every week.", icon: <BsCalendarHeart /> },
];

const navItems = [
  { icon: <MdHome />, label: "Home" },
  { icon: <MdDirectionsCarFilled />, label: "Rides" },
  { icon: <MdInfo />, label: "About" },
  { icon: <MdPerson />, label: "Profile" },
];

const desktopNav = ["Home", "Services", "About", "Fleet", "Contact"];

const statsData = [
  { value: "1L+", label: "Happy Riders", icon: <FaUsers /> },
  { value: "350+", label: "Pro Drivers", icon: <FaUsers /> },
  { value: "15+", label: "Cities", icon: <FiMapPin /> },
  { value: "4.9★", label: "Avg Rating", icon: <IoMdStar /> }
];

const KEYFRAMES = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Manrope:wght@300;400;500;600;700&display=swap');
  @keyframes drive { 0%{transform:translateX(-8px) rotate(-2deg)} 100%{transform:translateX(8px) rotate(2deg)} }
  @keyframes fadeUp { from{opacity:0;transform:translateY(28px)} to{opacity:1;transform:translateY(0)} }
  @keyframes fadeIn { from{opacity:0} to{opacity:1} }
  @keyframes pulse { 0%,100%{box-shadow:0 0 0 0 rgba(255,215,0,0.5)} 50%{box-shadow:0 0 0 14px rgba(255,215,0,0)} }
  @keyframes marquee { from{transform:translateX(0)} to{transform:translateX(-50%)} }
  @keyframes float { 0%{transform:translateY(0px)} 50%{transform:translateY(-10px)} 100%{transform:translateY(0px)} }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  ::-webkit-scrollbar { width: 6px; height: 4px; }
  ::-webkit-scrollbar-thumb { background: #FFC200; border-radius: 4px; }
`;

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return isMobile;
}

function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setInView(true); },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, inView];
}

export default function PlusCabsAbout() {
  const isMobile = useIsMobile();
  const [activeNav, setActiveNav] = useState("About");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const s = document.createElement("style");
    s.innerHTML = KEYFRAMES;
    document.head.appendChild(s);
    return () => { try { document.head.removeChild(s); } catch (_) {} };
  }, []);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <div style={{ fontFamily: "'Manrope', 'Segoe UI', sans-serif", background: WHITE, color: BLACK, minHeight: "100vh", overflowX: "hidden" }}>

      {/* ── HEADER ── */}
      {/* <Header scrolled={scrolled} isMobile={isMobile} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} /> */}

      {/* ── PAGE SECTIONS ── */}
      <HeroSection isMobile={isMobile} />
      <MarqueeBar />
      <StorySection isMobile={isMobile} />
      <StatsSection isMobile={isMobile} />
      <ValuesSection isMobile={isMobile} />
      {/* <TeamSection isMobile={isMobile} /> */}
      <TimelineSection isMobile={isMobile} />
      <CTASection isMobile={isMobile} />
      {/* <FooterSection isMobile={isMobile} /> */}

      {/* ── MOBILE BOTTOM NAV ── */}
     
    </div>
  );
}

/* ─── HEADER ─── */


/* ─── SHARED SUB COMPONENTS ─── */
function Logo() {
  return (
    <div style={{ fontFamily: "'Bebas Neue', Impact, sans-serif", fontSize: 28, color: YELLOW, letterSpacing: 2, lineHeight: 1 }}>
      PLUS<span style={{ color: WHITE }}>CABS</span>
    </div>
  );
}

function BookBtn({ large = false }) {
  const [hov, setHov] = useState(false);
  return (
    <button
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        background: YELLOW, color: BLACK, border: "none", borderRadius: 50,
        padding: large ? "15px 36px" : "10px 24px",
        fontWeight: 700, fontSize: large ? 15 : 13, cursor: "pointer",
        fontFamily: "'Manrope', sans-serif", letterSpacing: 0.3,
        boxShadow: hov ? "0 8px 28px rgba(255,215,0,0.55)" : "0 4px 16px rgba(255,215,0,0.35)",
        transform: hov ? "scale(1.04)" : "scale(1)",
        transition: "all 0.2s ease",
        display: "flex", alignItems: "center", gap: 8,
      }}>
      <FaCar /> Book a Ride
    </button>
  );
}

/* ── HERO ── */
/* ── HERO ── */
function HeroSection({ isMobile }) {
  const [ref, inView] = useInView(0.1);
  return (
    <section ref={ref} style={{
      background: BLACK, padding: isMobile ? "32px 20px 0" : "140px 80px 100px",
      position: "relative", overflow: "hidden",
      marginTop: isMobile ? 0 : 0,
    }}>
      <div style={{ position: "absolute", width: 480, height: 480, borderRadius: "50%", background: YELLOW, opacity: 0.05, top: -140, right: -120, pointerEvents: "none" }} />
      <div style={{ position: "absolute", width: 220, height: 220, borderRadius: "50%", background: YELLOW, opacity: 0.04, bottom: -60, left: -50, pointerEvents: "none" }} />

      <div style={{ maxWidth: 1160, margin: "0 auto", display: isMobile ? "block" : "grid", gridTemplateColumns: "1fr 1fr", alignItems: "center", gap: 72 }}>
        <div style={{ animation: inView ? "fadeUp 0.7s ease both" : "none" }}>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: 8,
            background: YELLOW, color: BLACK,
            fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase",
            padding: "6px 14px", borderRadius: 20, marginBottom: 22,
          }}>
            <FaTaxi /> ✦ About Plus Cabs
          </span>
          <h1 style={{
            fontFamily: "'Bebas Neue', Impact, sans-serif",
            fontSize: isMobile ? 58 : 84, color: WHITE,
            lineHeight: 0.93, letterSpacing: 1, marginBottom: 22,
          }}>
            We Drive<br />
            <span style={{ color: YELLOW }}>Your World</span><br />
            Forward
          </h1>
          <p style={{ color: "rgba(255,255,255,0.58)", fontSize: isMobile ? 14 : 16, lineHeight: 1.8, maxWidth: 460, marginBottom: 36 }}>
            Premium cab service built on trust, comfort, and the promise that every ride takes you exactly where you need to go — safely, on time, every time.
          </p>
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
            <button style={{
              background: YELLOW, color: BLACK, border: "none", borderRadius: 50,
              padding: "14px 34px", fontWeight: 700, fontSize: 14, cursor: "pointer",
              fontFamily: "'Manrope', sans-serif", animation: "pulse 2.5s infinite",
              display: "flex", alignItems: "center", gap: 8,
            }}><FaCar /> Book a Ride</button>
            <button style={{
              background: "transparent", color: WHITE,
              border: "1.5px solid rgba(255,255,255,0.28)", borderRadius: 50,
              padding: "14px 28px", fontWeight: 600, fontSize: 14, cursor: "pointer",
              fontFamily: "'Manrope', sans-serif", display: "flex", alignItems: "center", gap: 8,
            }}> <FiInfo /> Learn More →</button>
          </div>
        </div>

        {!isMobile && (
          <div style={{ display: "flex", justifyContent: "center", animation: inView ? "fadeIn 0.9s ease 0.3s both" : "none" }}>
            <div style={{
              background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,215,0,0.18)",
              borderRadius: 32, padding: "44px 48px", textAlign: "center",
              backdropFilter: "blur(10px)",
            }}>
              <div style={{ fontSize: 110, animation: "drive 2s ease-in-out infinite alternate", display: "inline-block" }}>
                <img src={Image1} alt="Hero Cab" style={{ width: 200, height: "auto", borderRadius: 20, objectFit: "cover" }} />
              </div>
              <div style={{ display: "flex", gap: 32, marginTop: 36, justifyContent: "center" }}>
                {statsData.slice(0,3).map((stat, index) => (
                  <div key={index} style={{ textAlign: "center" }}>
                    <div style={{ fontFamily: "'Bebas Neue', Impact, sans-serif", fontSize: 30, color: YELLOW, lineHeight: 1 }}>{stat.value}</div>
                    <div style={{ fontSize: 11, color: "rgba(255,255,255,0.45)", fontWeight: 500, marginTop: 4 }}>{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {isMobile && (
        <div style={{ background: YELLOW, margin: "32px -20px 0", padding: "22px 20px 16px", textAlign: "center" }}>
          <img src={Image1} alt="Hero Cab" style={{ width: 200, height: "auto", borderRadius: 20, objectFit: "cover" }} />
          <div style={{ display: "flex", justifyContent: "space-around", marginTop: 16 }}>
            {statsData.slice(0,3).map((stat, index) => (
              <div key={index} style={{ textAlign: "center" }}>
                <div style={{ fontFamily: "'Bebas Neue', Impact, sans-serif", fontSize: 24, color: BLACK, lineHeight: 1 }}>{stat.value}</div>
                <div style={{ fontSize: 10, color: "rgba(0,0,0,0.5)", fontWeight: 600, marginTop: 2 }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}

/* ── MARQUEE ── */
function MarqueeBar() {
  const items = [
    { icon: <FaTaxi />, text: "Safe Rides" },
    { icon: <FaClock />, text: "On Time" },
    { icon: <FaLeaf />, text: "Eco Fleet" },
    { icon: <FaTrophy />, text: "Award Winning" },
    { icon: <FaCity />, text: "15+ Cities" },
    { icon: <FaStar />, text: "4.9 Rated" },
    { icon: <FaShieldAlt />, text: "Verified Drivers" },
    { icon: <FaCreditCard />, text: "Easy Payments" }
  ];
  
  const doubled = [...items, ...items];
  
  return (
    <div style={{ background: YELLOW, padding: "13px 0", overflow: "hidden", whiteSpace: "nowrap" }}>
      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
      <div style={{ 
        display: "inline-flex", 
        gap: 52, 
        animation: "marquee 22s linear infinite",
        alignItems: "center"
      }}>
        {doubled.map((item, i) => (
          <span 
            key={i} 
            style={{ 
              fontSize: 13, 
              fontWeight: 700, 
              letterSpacing: 0.5, 
              color: BLACK, 
              flexShrink: 0,
              display: "inline-flex",
              alignItems: "center",
              gap: "6px"
            }}
          >
            <span style={{ fontSize: "16px", display: "inline-flex" }}>{item.icon}</span>
            {item.text}
          </span>
        ))}
      </div>
    </div>
  );
}

/* ── STORY ── */
function StorySection({ isMobile }) {
  const [ref, inView] = useInView();
  const storyItems = [
    { icon: <GiCityCar />, title: "15+ Cities", sub: "And expanding fast" },
    { icon: <FaUsers />, title: "350+ Drivers", sub: "Vetted & trained" },
    { icon: <IoMdStar />, title: "4.9 Rating", sub: "From 50K+ riders" },
    { icon: <IoIosLeaf />, title: "30% EV Fleet", sub: "Going green daily" },
  ];
  
  return (
    <section ref={ref} style={{ padding: isMobile ? "44px 20px" : "90px 80px" }}>
      <div style={{ maxWidth: 1160, margin: "0 auto", display: isMobile ? "block" : "grid", gridTemplateColumns: "1fr 1fr", gap: 88, alignItems: "center" }}>
        <div style={{ animation: inView ? "fadeUp 0.6s ease both" : "none" }}>
          <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2.5, textTransform: "uppercase", color: YELLOW_DARK, display: "flex", alignItems: "center", gap: 8 }}>
            <MdTimeline /> Our Story
          </span>
          <h2 style={{ fontFamily: "'Bebas Neue', Impact, sans-serif", fontSize: isMobile ? 40 : 56, lineHeight: 1, marginTop: 8, marginBottom: 20 }}>Born From a Simple Idea</h2>
          <p style={{ fontSize: 15, color: "#444", lineHeight: 1.82, marginBottom: 16 }}>
            Plus Cabs was founded in 2021 with one goal: make every journey feel like a first-class experience — regardless of the destination. We started with 10 cars and a vision rooted in reliability and care.
          </p>
          <p style={{ fontSize: 15, color: "#444", lineHeight: 1.82 }}>
            Today, we're one of the most trusted ride services in the region — serving hundreds of thousands of passengers across 15+ cities with a growing fleet of professional, trained drivers.
          </p>
        </div>
        <div style={{
          display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16,
          marginTop: isMobile ? 32 : 0,
          animation: inView ? "fadeUp 0.6s ease 0.2s both" : "none",
        }}>
          {storyItems.map(({ icon, title, sub }) => (
            <div key={title} style={{
              background: YELLOW_LIGHT, borderRadius: 20, padding: "24px 18px",
              border: `1px solid rgba(255,215,0,0.3)`,
            }}>
              <div style={{ fontSize: 34, marginBottom: 10, color: YELLOW_DARK }}>{icon}</div>
              <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 3 }}>{title}</div>
              <div style={{ fontSize: 12, color: "#777" }}>{sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ── STATS ── */
function StatsSection({ isMobile }) {
  const [ref, inView] = useInView();
  
  return (
    <div ref={ref} style={{ padding: isMobile ? "0 16px 8px" : "0 80px 16px" }}>
      <div style={{
        background: BLACK, borderRadius: 28,
        padding: isMobile ? "32px 20px" : "52px 72px",
        maxWidth: 1160, margin: "0 auto",
      }}>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(2,1fr)" : "repeat(4,1fr)", gap: isMobile ? 24 : 0 }}>
          {statsData.map((stat, i) => (
            <div key={i} style={{
              textAlign: "center", padding: "16px 8px",
              borderRight: !isMobile && i < 3 ? "1px solid rgba(255,255,255,0.1)" : "none",
              animation: inView ? `fadeUp 0.5s ease ${i * 0.1}s both` : "none",
            }}>
              <div style={{ fontSize: 30, marginBottom: 8, color: YELLOW }}>{stat.icon}</div>
              <div style={{ fontFamily: "'Bebas Neue', Impact, sans-serif", fontSize: isMobile ? 40 : 52, color: YELLOW, lineHeight: 1 }}>{stat.value}</div>
              <div style={{ fontSize: 12, color: "rgba(255,255,255,0.45)", marginTop: 7, fontWeight: 500 }}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ── VALUES ── */
function ValuesSection({ isMobile }) {
  const [ref, inView] = useInView();
  return (
    <section ref={ref} style={{ background: GRAY_BG, padding: isMobile ? "44px 20px" : "90px 80px" }}>
      <div style={{ maxWidth: 1160, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 52 }}>
          <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2.5, textTransform: "uppercase", color: YELLOW_DARK, display: "inline-flex", alignItems: "center", gap: 8 }}>
            <FaHeart /> What We Stand For
          </span>
          <h2 style={{ fontFamily: "'Bebas Neue', Impact, sans-serif", fontSize: isMobile ? 40 : 56, marginTop: 8 }}>Our Core Values</h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3,1fr)", gap: 20 }}>
          {values.map((v, i) => (
            <ValueCard key={i} v={v} delay={i * 0.08} inView={inView} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ValueCard({ v, delay, inView }) {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        background: hov ? BLACK : WHITE, borderRadius: 20,
        padding: "26px 22px", borderLeft: `4px solid ${YELLOW}`,
        boxShadow: hov ? "0 14px 44px rgba(0,0,0,0.15)" : "0 2px 14px rgba(0,0,0,0.05)",
        transition: "all 0.25s ease", cursor: "default",
        animation: inView ? `fadeUp 0.5s ease ${delay}s both` : "none",
      }}>
      <div style={{
        width: 50, height: 50, borderRadius: 14,
        background: hov ? YELLOW : YELLOW_LIGHT,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: 24, marginBottom: 16, transition: "background 0.25s",
        color: hov ? BLACK : YELLOW_DARK,
      }}>{v.icon}</div>
      <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 8, color: hov ? WHITE : BLACK, transition: "color 0.25s" }}>{v.title}</h3>
      <p style={{ fontSize: 13, lineHeight: 1.68, color: hov ? "rgba(255,255,255,0.62)" : "#555", transition: "color 0.25s" }}>{v.desc}</p>
    </div>
  );
}

/* ── TEAM ── */
function TeamSection({ isMobile }) {
  const [ref, inView] = useInView();
  return (
    <section ref={ref} style={{ padding: isMobile ? "44px 20px" : "90px 80px" }}>
      <div style={{ maxWidth: 1160, margin: "0 auto" }}>
        <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2.5, textTransform: "uppercase", color: YELLOW_DARK, display: "flex", alignItems: "center", gap: 8 }}>
          <MdPeople /> The Team
        </span>
        <h2 style={{ fontFamily: "'Bebas Neue', Impact, sans-serif", fontSize: isMobile ? 40 : 56, marginTop: 8, marginBottom: 36 }}>Meet The Crew</h2>
        <div style={{
          display: isMobile ? "flex" : "grid",
          gridTemplateColumns: "repeat(6,1fr)",
          gap: 16, overflowX: isMobile ? "auto" : "visible",
          paddingBottom: isMobile ? 8 : 0, scrollbarWidth: "none",
        }}>
          {teamMembers.map((m, i) => (
            <TeamCard key={i} m={m} delay={i * 0.09} inView={inView} isMobile={isMobile} />
          ))}
        </div>
      </div>
    </section>
  );
}

function TeamCard({ m, delay, inView, isMobile }) {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        flexShrink: 0, minWidth: isMobile ? 130 : "auto",
        background: hov ? YELLOW_LIGHT : GRAY_BG,
        borderRadius: 20, padding: "20px 12px", textAlign: "center",
        border: hov ? `2px solid ${YELLOW}` : "2px solid transparent",
        transition: "all 0.22s ease", cursor: "default",
        animation: inView ? `fadeUp 0.5s ease ${delay}s both` : "none",
      }}>
      <div style={{
        width: 66, height: 66, borderRadius: "50%",
        margin: "0 auto 12px", background: m.bg,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: 28, border: `3px solid ${hov ? YELLOW_DARK : "transparent"}`,
        transition: "border 0.22s", color: BLACK,
      }}>{m.icon}</div>
      <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 2 }}>{m.name}</div>
      <div style={{ fontSize: 11, color: "#888" }}>{m.role}</div>
    </div>
  );
}

/* ── TIMELINE ── */
function TimelineSection({ isMobile }) {
  const [ref, inView] = useInView();
  return (
    <section ref={ref} style={{ background: YELLOW_LIGHT, padding: isMobile ? "44px 20px" : "90px 80px" }}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2.5, textTransform: "uppercase", color: YELLOW_DARK, display: "flex", alignItems: "center", gap: 8 }}>
          <BsCalendarHeart /> Our Journey
        </span>
        <h2 style={{ fontFamily: "'Bebas Neue', Impact, sans-serif", fontSize: isMobile ? 40 : 56, marginTop: 8, marginBottom: 44 }}>How We Got Here</h2>
        <div style={{ position: "relative" }}>
          {!isMobile && (
            <div style={{ position: "absolute", left: 78, top: 16, bottom: 16, width: 2, background: "rgba(255,194,0,0.35)" }} />
          )}
          {timeline.map((t, i) => (
            <div key={i} style={{
              display: "flex", gap: isMobile ? 16 : 32,
              marginBottom: 24, alignItems: "flex-start",
              animation: inView ? `fadeUp 0.5s ease ${i * 0.1}s both` : "none",
            }}>
              <div style={{ flexShrink: 0, width: isMobile ? 50 : 90, display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div style={{
                  background: YELLOW_DARK, color: BLACK,
                  fontFamily: "'Bebas Neue', Impact, sans-serif",
                  fontSize: isMobile ? 15 : 20, padding: "5px 10px",
                  borderRadius: 10, lineHeight: 1, whiteSpace: "nowrap",
                  display: "flex", alignItems: "center", gap: 4,
                }}>
                  {t.icon} {t.year}
                </div>
              </div>
              <div style={{
                background: WHITE, borderRadius: 18, padding: "18px 22px", flex: 1,
                boxShadow: "0 2px 18px rgba(0,0,0,0.06)",
                border: "1px solid rgba(255,215,0,0.22)",
              }}>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 5, display: "flex", alignItems: "center", gap: 8 }}>
                  {t.icon} {t.title}
                </div>
                <p style={{ fontSize: 13, color: "#555", lineHeight: 1.58 }}>{t.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ── CTA ── */
function CTASection({ isMobile }) {
  const [ref, inView] = useInView();
  return (
    <section ref={ref} style={{ padding: isMobile ? "20px 16px 32px" : "60px 80px" }}>
      <div style={{
        background: BLACK, borderRadius: 28, maxWidth: 1160, margin: "0 auto",
        padding: isMobile ? "40px 28px" : "72px 100px", textAlign: "center",
        position: "relative", overflow: "hidden",
        animation: inView ? "fadeUp 0.6s ease both" : "none",
      }}>
        <div style={{ position: "absolute", width: 360, height: 360, borderRadius: "50%", background: YELLOW, opacity: 0.06, bottom: -110, right: -70, pointerEvents: "none" }} />
        <div style={{ position: "absolute", width: 200, height: 200, borderRadius: "50%", background: YELLOW, opacity: 0.04, top: -70, left: -50, pointerEvents: "none" }} />
        <div style={{ fontFamily: "'Bebas Neue', Impact, sans-serif", fontSize: isMobile ? 44 : 68, color: WHITE, letterSpacing: 1, marginBottom: 14 }}>
          Ready To <span style={{ color: YELLOW }}>Ride?</span>
        </div>
        <p style={{ color: "rgba(255,255,255,0.52)", fontSize: isMobile ? 14 : 16, maxWidth: 520, margin: "0 auto 32px", lineHeight: 1.75, display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <FaRocket /> Download the app or book instantly online. Your next ride is just a tap away.
        </p>
        <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
          <BookBtn large />
          <button style={{
            background: "transparent", color: WHITE,
            border: "1.5px solid rgba(255,255,255,0.25)", borderRadius: 50,
            padding: "15px 32px", fontWeight: 600, fontSize: 15, cursor: "pointer",
            fontFamily: "'Manrope', sans-serif", display: "flex", alignItems: "center", gap: 8,
          }}> <MdDirectionsCarFilled  /> Download App</button>
        </div>
      </div>
    </section>
  );
}

/* ── FOOTER ── */
function FooterSection({ isMobile }) {
  return (
    <footer style={{ background: BLACK, padding: isMobile ? "40px 20px 80px" : "60px 80px 80px", color: "rgba(255,255,255,0.7)" }}>
      <div style={{ maxWidth: 1160, margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "2fr 1fr 1fr 1.5fr", gap: 40, marginBottom: 48 }}>
          <div>
            <Logo />
            <p style={{ fontSize: 13, lineHeight: 1.8, marginTop: 20, maxWidth: 280 }}>
              Premium cab service built on trust, comfort, and the promise that every ride takes you exactly where you need to go.
            </p>
            <div style={{ display: "flex", gap: 16, marginTop: 24 }}>
              <FaFacebook size={20} style={{ cursor: "pointer", opacity: 0.7, transition: "opacity 0.2s" }} />
              <FaTwitter size={20} style={{ cursor: "pointer", opacity: 0.7, transition: "opacity 0.2s" }} />
              <FaInstagram size={20} style={{ cursor: "pointer", opacity: 0.7, transition: "opacity 0.2s" }} />
              <FaLinkedin size={20} style={{ cursor: "pointer", opacity: 0.7, transition: "opacity 0.2s" }} />
            </div>
          </div>
          
          <div>
            <h4 style={{ color: WHITE, fontSize: 14, marginBottom: 16, fontWeight: 600 }}>Quick Links</h4>
            {["About Us", "Services", "Fleet", "Contact", "Blog"].map(item => (
              <div key={item} style={{ marginBottom: 10, fontSize: 13, cursor: "pointer", opacity: 0.8 }}>{item}</div>
            ))}
          </div>
          
          <div>
            <h4 style={{ color: WHITE, fontSize: 14, marginBottom: 16, fontWeight: 600 }}>Support</h4>
            {["FAQ", "Terms", "Privacy", "Safety", "Careers"].map(item => (
              <div key={item} style={{ marginBottom: 10, fontSize: 13, cursor: "pointer", opacity: 0.8 }}>{item}</div>
            ))}
          </div>
          
          <div>
            <h4 style={{ color: WHITE, fontSize: 14, marginBottom: 16, fontWeight: 600 }}>Contact</h4>
            <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 12, fontSize: 13 }}>
              <FaPhone size={14} /> +1 234 567 8900
            </div>
            <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 12, fontSize: 13 }}>
              <FaEnvelope size={14} /> hello@pluscabs.com
            </div>
            <div style={{ display: "flex", gap: 10, alignItems: "flex-start", marginBottom: 12, fontSize: 13 }}>
              <FiMapPin size={14} style={{ marginTop: 2 }} /> 123 Business Ave, Suite 100, City, Country
            </div>
            <div style={{ display: "flex", gap: 16, marginTop: 24 }}>
              <FaApple size={24} style={{ cursor: "pointer" }} />
              <FaGooglePlay size={22} style={{ cursor: "pointer" }} />
            </div>
          </div>
        </div>
        
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.1)", paddingTop: 24, textAlign: "center", fontSize: 12 }}>
          © {new Date().getFullYear()} Plus Cabs. All rights reserved. Made with <FaHeart color={YELLOW} style={{ display: "inline", margin: "0 4px" }} /> for better rides.
        </div>
      </div>
    </footer>
  );
}